import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import SearchInput from '../@generalComponents/SearchInput';

const MobileSidebar = dynamic(() => import('./MobileSidebar'), {
	ssr: false,
	loading: () => <p>Loading...</p>,
});

const Header = ({ categories }) => {
	const router = useRouter();
	useEffect(() => {
		const preloadImage = document.createElement('link');
		preloadImage.rel = 'preload';
		preloadImage.href = '/images/header-graphic.jpg';
		preloadImage.as = 'image';
		document.head.appendChild(preloadImage);
		return () => {
			if (document.head.contains(preloadImage)) {
				document.head.removeChild(preloadImage);
			}
		};
	}, []);

	return (
		<div className='bg-[#00BFFF] p-8 pb-8 pt-4 px-6 md:pr-12 md:pl-12 mb-2'>
			<div className='flex -m-0.5'>
				<div className='lg:w-1/2 flex items-center'>
					<div>
						<h1 className='mb-3 text-[34px] md:text-[35px] font-bold leading-[120%] w-full max-w-[590px] h-full md:max-h-[84px]'>
							The world's #1 search engine for text messages
						</h1>
						<div className='mb-3 text-lg font-medium'>
							Follow, save and share texts from your favorite brands
						</div>
						<SearchInput navigateToSearchPage />
					</div>
				</div>
				<div className='hidden lg:flex lg:w-1/2 justify-end'>
					<picture>
						<source
							srcSet='/images/header-graphic.webp'
							type='image/webp'
						/>
						<Image
							alt='header-graphic'
							className='aspect-[256/185] w-full max-w-[510px] h-full max-h-[368px] rounded-[60px] shadow-md bg-gray-300 block md:h-auto'
							src='/images/header-graphic.jpg'
							width={510}
							height={368}
							priority
							loading='eager'
							fetchPriority='high'
							layout='intrinsic'
							sizes='(max-width: 768px) 100vw, 510px'
							quality={70}
							style={{ backgroundColor: '#D3D3D3' }}
						/>
					</picture>
				</div>
			</div>
		</div>
	);
};

export default Header;
